/**
  * @function evaluate - evaluate taggedFormTypeOptionsBehavior
  */

export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const tagOptions = (await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'tag/options'
  })) || {};
  const formTypeOptions = {};
  Object.keys(tagOptions).forEach(key => {
    const {
      title,
      _created,
      children
    } = tagOptions[key];
    if (children !== undefined && Object.keys(children).length > 0) {
      formTypeOptions[key] = {
        title,
        _created
      };
    }
  });
  return formTypeOptions;
};
export default {
  evaluate
};